const style = {

  activeStep: {
    "& img": {
      transform: "scale(1.2, 1.2)",
    },
    "& span": {
      //   color: theme.palette.primary.main,
      fontSize: "1.1 rem",
      color: "#605edf",
    },
  },
  bulkEditPaper: {
    // width: 700,
    height: 550,
  },
  phoneList: {
    maxHeight: 300,
    maxWidth: 200,
    overflowWrap: "break-work",
  },
  phoneListItem: {
    whiteSpace: "normal",
  },
  step: {
    width: 100,
    // color: theme.palette.grey[500],
  },
  successStep: {
    color: "#67d238",
  },
  stepper: {
    height: 57,
    width: 200,
  },
  extensionInput: {
    width: "305px!important",
  },
  // formSectionWrapper: {
  //   width: 700,
  //   // paddingLeft: theme.spacing(10),
  //   // marginTop: props => (props.showAll ? theme.spacing(10) : 0),
  // },
};

export default style;
